export default __webpack_public_path__ + "static/media/r9.0fa456e3.jpg";